import React, { ChangeEvent,  useState } from "react";
import Webcamera from "./Webcamera";
import camera from "../../assets/icons/camera.png";
import { useParams } from "react-router-dom";
function ImputImage({
  name,
  type,
  onChange,
  value,
  isDisable,
}: any) {
  const [opencamera, setopencamera] = useState(false);
  const [images, setimages] = useState<string | null>(null);
  const [, setcaptureImage] = useState<string | null>(null);
  const { ID } = useParams();

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setimages(event.target.value);

    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setcaptureImage(result);
      onChange({
        target: { name: name || "", value: result }, // Provide a default value for 'name'
      });
    };
    reader.readAsDataURL(file);
  };
  const handleWebcam = (e: any) => {
    onChange({
      target: { name: name || "", value: e }, // Provide a default value for 'name'
    });
  };
  return (
    <>
      <div className="space-y-3">
        <label className="block text-sm font-normal capitalize text-slate-700 dark:text-slate-300">
          Patient Image
        </label>
        <div className="flex flex-wrap gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium text-gray-500 dark:text-slate-400">
              Select Image
            </label>
            <input
              disabled={isDisable}
              value={images ?? ""}
              type={type}
              accept="image/*"
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-600 dark:text-slate-300 file:mr-3 file:rounded-md file:border-0 file:bg-gray-100 dark:file:bg-slate-700 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-700 dark:file:text-slate-200 hover:file:bg-gray-200 dark:hover:file:bg-slate-600 disabled:cursor-not-allowed disabled:opacity-60"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium text-gray-500 dark:text-slate-400">
              Open Webcam
            </label>
            <div
              onClick={() => {
                !isDisable && setopencamera(true);
              }}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-gray-300 dark:border-slate-600 bg-gray-50 dark:bg-slate-700 transition-colors hover:bg-gray-100 dark:hover:bg-slate-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <img src={camera} alt="" className="h-5 w-5 object-contain dark:invert" />
            </div>
          </div>
        </div>
        <div className="flex justify-center rounded-lg border border-gray-200 dark:border-slate-600 bg-gray-50 dark:bg-slate-700 p-4">
          <img
            src={
              value
                ? ID
                  ? value?.length > 400
                    ? value
                    : `${process.env.REACT_APP_API}${value}`
                  : value
                : camera
            }
            alt=""
            className="max-h-48 w-auto max-w-full object-contain"
          />
        </div>
      </div>

      {opencamera && (
        <Webcamera
          handleWebcam={handleWebcam}
          setcaptureImage={setcaptureImage}
          setopencamera={setopencamera}
        />
      )}
    </>
  );
}

export default ImputImage;
